<template>
    <form id="add_task_form" :action="store_route" method="post" enctype="multipart/form-data" class="mt-5"
          @submit="checkValidation">
        <input type="hidden" name="_token" v-bind:value="csrf">

        <div class="panel-group col-12 px-0" id="accordion" role="tablist" aria-multiselectable="true">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 p-0 panel-heading" role="tab">
            <button type="button" class="btn-no-style col-12 p-0 text-left panel-title" data-toggle="collapse" ref="taskClientSectionButton"
                    data-parent="#accordion" href="#taskClient" :aria-expanded="is_admin || systems.length > 1 ? 'true' : 'false'" aria-controls="taskClient">
                <h4 class="font-weight-bold">{{ $lang('Zgłoszenie dotyczy') }}</h4>
                <hr class="colorgraph">
            </button>
        </div>
        <div id="taskClient" :class="['panel-collapse collapse', is_admin || systems.length > 1 ? 'show' : 'in']" role="tabpanel">
            <div class="form-group" ref="libraryID">
                <template v-if="is_admin">
                    <label for="librarySelect">{{ $lang('Biblioteka') }} </label>
                    <div class="input-group mb-2">
                        <div class="input-group-prepend">
                            <div class="bg-icon"><i class="fa fa-university" aria-hidden="true"></i></div>
                        </div>
                        <libraries-chooser :name="'library'" :id="'librarySelect'" :default-library="libraryID"
                                           :libraries="libraries" :error="errors['libraryID'] !== undefined">
                        </libraries-chooser>
                        <input type="hidden" name="library" v-model="libraryID" v-if="libraries.length === 1">
                    </div>
                </template>
                <template v-else>
                    <label for="libraryInput">{{ $lang('Biblioteka') }} </label>
                    <input id="libraryInput" name="library" :value="client.id" hidden>
                    <p><strong>{{ client.name }}</strong></p>
                </template>
                <div class="form-group" v-if="contractNo" :ref="'contractNo'">
                    <label for="contract_no">{{ $lang('Numer umowy') }} </label>
                    <input type="text" id="contract_no" class="form-control control-pre-filled" v-model="contractNo" name="contract_no"
                           :class="{'border-danger':errors['contractNo'] !== undefined}" readonly>
                    </input>
                </div>
                <div class="row" v-if="systems">
                    <div class="col-12" :ref="'systemID'">
                        <div class="form-group">
                            <label for="system">{{ $lang('System') }} <span class="text-red"> {{
                                    $lang('(wymagane)')
                                }} </span> </label>
                            <div class="input-group mb-2">
                                <div class="input-group-prepend">
                                    <div class="bg-icon"><i class="fa fa-cog" aria-hidden="true"></i></div>
                                </div>
                                <select id="system" name="system" class="form-control"
                                        :class="{'border-danger':errors['systemID'] !== undefined}"
                                        :style="{pointerEvents: systemPointerEvents}"
                                        v-model="systemID" :readonly="systems.length === 1">
                                    <option v-for="system in systems" :value="system.product_id">
                                        {{ system.product.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4" :ref="'systemVersion'">
                        <div class="form-group">
                            <label for="system_version">{{ $lang('Wersja produkcyjna systemu') }}<span
                                class="text-red"> {{ $lang('(wymagane)') }}</span></label>
                            <input :style="{pointerEvents: systemVersionEdit ? 'auto' : 'none'}"
                                   :readonly="!systemVersionEdit" type="text" id="system_version" class="form-control"
                                   :class="{'border-danger':errors['systemVersion'] !== undefined}"
                                   v-model="systemVersion" name="system_version"
                                   :placeholder="$lang('Wersja produkcyjna systemu')">
                            </input>
                        </div>
                    </div>
                    <div class="col-12 col-md-4" :ref="'databaseVersion'">
                        <div class="form-group">
                            <label for="database_version">{{ $lang('Wersja bazy danych') }}<span
                                class="text-red"> {{ $lang('(wymagane)') }}</span></label>
                            <input :style="{pointerEvents: databaseVersionEdit ? 'auto' : 'none'}"
                                   :readonly="!databaseVersionEdit" type="text" id="database_version" class="form-control"
                                   :class="{'border-danger':errors['databaseVersion'] !== undefined}"
                                   v-model="databaseVersion" name="database_version"
                                   :placeholder="$lang('Wersja bazy danych')">
                            </input>
                        </div>
                    </div>
                    <div class="col-12 col-md-4" :ref="'osVersion'">
                        <div class="form-group">
                            <label for="os_version">{{ $lang('Wersja systemu operacyjnego') }}<span
                                class="text-red"> {{ $lang('(wymagane)') }}</span></label>
                            <input :style="{pointerEvents: osVersionEdit ? 'auto' : 'none'}" :readonly="!osVersionEdit"
                                   type="text" id="os_version" class="form-control" v-model="osVersion" name="os_version"
                                   :class="{'border-danger':errors['osVersion'] !== undefined}"
                                   :placeholder="$lang('Wersja systemu operacyjnego')">
                            </input>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-12 p-0 panel-heading mt-5" role="tab">
            <button type="button" class="btn-no-style col-12 p-0 text-left panel-title" data-toggle="collapse" ref="taskPersonSectionButton"
                    data-parent="#accordion" href="#taskPerson" :aria-expanded="is_admin ? 'true' : 'false'" aria-controls="taskPerson">
                <h4 class="font-weight-bold">{{ $lang('Osoba tworząca zgłoszenie') }}</h4>
                <hr class="colorgraph">
            </button>
        </div>
        <div id="taskPerson" :class="['panel-collapse collapse', is_admin ? 'show' : 'in']" role="tabpanel">
            <div class="row">
                <div class="col-xl-6 form-group" :ref="'surnameInput'">
                    <input type="number" hidden name="person_id" v-model="person_id"/>
                    <label for="surname">{{ $lang('Nazwisko ') }}
                        <span class="text-red"> {{ $lang('(wymagane)') }} </span>
                    </label>
                    <div class="input-group mb-2">
                        <div class="input-group-prepend">
                            <div class="bg-icon"><i class="fa fa-user" aria-hidden="true"></i></div>
                        </div>
                        <input id="surname" type="text" class="form-control control-pre-filled" name="surname"
                               :class="{'border-danger':errors['surnameInput'] !== undefined}"
                               :value="surname" :readonly="true" v-if="!is_admin">
                        <template v-else>
                            <input id="surname" type="hidden" name="surname" :value="surname">
                            <autocomplete
                                :autoSelect="true"
                                ref="surname"
                                :search="searchPeopleSurname"
                                @submit="handleSurname"
                                :placeholder="$lang('Nazwisko')"
                                :get-result-value="getResult"
                                class="autocomplete-wrapper"
                            ></autocomplete>
                        </template>
                    </div>
                    <small class="text-red small-70" v-if="is_admin && !validatePerson() && name!=='' && surname!==''">
                        <span style="color: red" v-if="!can_add_people">
                            {{ $lang(`Brak nazwiska w bazie.`) }}
                        </span>
                        <a :href="add_person_route+'?tab=people'" style="color: red" v-else>
                            {{ $lang(`Brak nazwiska w bazie. Kliknij aby dodać osobę.`) }}
                        </a>
                    </small>
                </div>

                <div class="col-xl-6 form-group" :ref="'nameInput'">
                    <label for="name">{{ $lang('Imię ') }}
                        <span class="text-red"> {{ $lang('(wymagane)') }} </span>
                    </label>

                    <div class="input-group mb-2">
                        <div class="input-group-prepend">
                            <div class="bg-icon"><i class="fa fa-user" aria-hidden="true"></i></div>
                        </div>
                        <input id="name" type="text" class="form-control control-pre-filled"
                               :class="{'border-danger':errors['nameInput'] !== undefined}"
                               name="name" :value="name" :readonly="true" v-if="!is_admin">
                        <template v-else>
                            <input id="name" type="hidden" name="name" :value="name">
                            <autocomplete
                                :autoSelect="true"
                                ref="name"
                                :search="searchPeopleName"
                                @submit="handleName"
                                :placeholder="$lang('Imię')"
                                :get-result-value="getResult"
                                class="autocomplete-wrapper"
                            ></autocomplete>
                        </template>
                    </div>


                </div>
            </div>
            <div class="row">
                <div class="col-xl-6 form-group" :ref="'email'">
                    <label for="email">{{ $lang('E-mail ') }}</label>
                    <div class="input-group mb-2">
                        <div class="input-group-prepend">
                            <div class="bg-icon"><i class="fa fa-envelope" aria-hidden="true"></i></div>
                        </div>
                        <input type="text" class="form-control control-pre-filled" id="email" name="email"
                               :class="{'border-danger':errors['email'] !== undefined}"
                               :placeholder="$lang('E-mail')" v-model="email" :readonly="true">
                    </div>
                </div>

                <div class="col-xl-6 form-group">
                    <label for="phone_number">{{ $lang('Telefon ') }}</label>
                    <div class="input-group mb-2">
                        <div class="input-group-prepend">
                            <div class="bg-icon"><i class="fa fa-phone" aria-hidden="true"></i></div>
                        </div>
                        <input type="text" class="form-control control-pre-filled" id="phone_number" name="phone_number" v-model="phone"
                               :readonly="true">
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label for="additional_contact">{{
                        $lang('Dodatkowa osoba do kontaktu (imię, nazwisko, telefon)')
                    }} </label>
                <input type="text" id="additional_contact" class="form-control" v-model="additionalContact"
                       name="additional_contact">
                </input>
            </div>
        </div>
        </div>

        <template v-if="modules && basicCriteria">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 p-0 panel-heading mt-5" role="tab">
                <button type="button" class="btn-no-style col-12 p-0 text-left panel-title" data-toggle="collapse" ref="taskTypeSectionButton"
                        data-parent="#accordion" href="#taskType" aria-expanded="true" aria-controls="taskType">
                    <h4 class="font-weight-bold">{{ $lang('Typ zgłoszenia') }}</h4>
                    <hr class="colorgraph">
                </button>
            </div>
            <div id="taskType" class="panel-collapse collapse show" role="tabpanel">
                <div class="row">
                    <div class="col-12" :ref="'moduleID'">
                        <div class="form-group">
                            <div :ref="'basicCriterion'">
                                <label for="basic_criterion">
                                    {{ $lang('Kryterium') }}
                                    <span class="text-red">{{ $lang('(wymagane)') }}</span>
                                </label>
                                <select id="basic_criterion" class="form-control" v-model="basicCriterion"
                                        :class="{'border-danger':errors['basicCriterion'] !== undefined}">
                                    <option v-for="basic_criterion in basicCriteria" :value="basic_criterion.criterion_id">
                                        {{ basic_criterion.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="mt-3" :ref="'priorityCriterion'"
                                 v-if="priorityCriteria.filter(criterion => criterion.part_of === basicCriterion).length > 0">
                                <label for="priority_criterion">
                                    {{ $lang('Priorytet') }}
                                    <span class="text-red">{{ $lang('(wymagane)') }}</span>
                                </label>
                                <select id="priority_criterion" class="form-control" v-model="priorityCriterion"
                                        :class="{'border-danger':errors['priorityCriterion'] !== undefined}">
                                    <option v-for="priority_criterion in priorityCriteria"
                                            :value="priority_criterion.criterion_id">
                                        {{ priority_criterion.name }}
                                    </option>
                                </select>
                            </div>
                            <input type="hidden" id="criterion" name="criterion" :value="criterionType"></input>
                        </div>
                        <div class="form-group" v-if="modules">
                            <label for="module">{{ $lang('Moduł') }} <span class="text-red"> {{
                                    $lang('(wymagane)')
                                }} </span> </label>
                            <div class="input-group mb-2">
                                <div class="input-group-prepend">
                                    <div class="bg-icon"><i class="fa fa-puzzle-piece" aria-hidden="true"></i></div>
                                </div>
                                <select :class="{'control-pre-filled': modules.length === 1, 'border-danger':errors['moduleID'] !== undefined}"
                                        :readonly="modules.length === 1" id="module" name="module" class="form-control" v-model="moduleID">
                                    <option v-for="module in modules" :value="module.module_id">{{ module.name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group" v-if="criterionType!==null">
                    <useful-links v-bind:criterion_type="criterionType" :useful_links="useful_links"></useful-links>
                </div>
            </div>
        </template>


        <div class="col-12 col-sm-12 col-md-12 col-lg-12 p-0 panel-heading mt-5" role="tab">
            <button type="button" class="btn-no-style col-12 p-0 text-left panel-title" data-toggle="collapse" ref="taskDataSectionButton"
                    data-parent="#accordion" href="#taskData" aria-expanded="true" aria-controls="taskData">
                <h4 class="font-weight-bold">{{ $lang('Zgłoszenie') }}</h4>
                <hr class="colorgraph">
            </button>
        </div>
        <div id="taskData" class="panel-collapse collapse show" role="tabpanel">
            <div class="form-group" :ref="'subject'">
                <label for="subject">{{ $lang('Temat') }} <span
                    class="text-red">{{ $lang('(wymagane)') }}</span> </label>
                <div class="input-group mb-2">
                    <div class="input-group-prepend">
                        <div class="bg-icon"><i class="fa fa-quote-left" aria-hidden="true"></i></div>
                    </div>
                    <input type="text" class="form-control" id="subject" name="subject" maxlength="200" v-model="subject"
                           :class="{'border-danger':errors['subject'] !== undefined}">
                </div>
            </div>
            <div class="form-group" :ref="'description'">
                <label for="description">{{ $lang('Opis') }} <span
                    class="text-red">{{ $lang('(wymagane)') }}</span></label>
                <textarea class="form-control" id="description" name="description" rows="5" v-model="description"
                          :class="{'border-danger':errors['description'] !== undefined}">
                </textarea>
            </div>
            <div class="form-group" :ref="'source'" v-if="is_admin && projectID">
                <label for="source">{{ $lang('Źródło') }} <span
                    class="text-red">{{ $lang('(wymagane)') }}</span> </label>
                <select id="source" class="form-control" v-model="source" name="source"
                        :class="{'border-danger':errors['source'] !== undefined}">
                    <option v-for="sourceOption in sourcesForProject" :value="sourceOption.name">
                        {{ sourceOption.name }}
                    </option>
                </select>
            </div>
            <div class="form-group" v-if="is_admin && projectID && source !== 'www'" :ref="'reportedAt'">
                <datepicker-accessible
                    id="reported_at"
                    :label-single="$lang('Data zgłoszenia')"
                    custom-id="reported_at"
                    name="reported_at"
                    mode="datetime"
                    :use_pencil_checkbox="false"
                    :strong_label="false"
                    v-model="reportedAt"
                    class="mt-0"
                    :has_error="errors['reportedAt'] !== undefined"
                ></datepicker-accessible>
                <span class="text-danger mt-1 mb-3" v-if="errors['reportedAt'] !== undefined">
                    <small v-if="errors['reportedAt'] === 'date_format'">
                        {{$lang('Wprowadź pełną datę')}}
                    </small>
                    <small v-else-if="errors['reportedAt'] === 'later_date'">
                        {{$lang('Data zgłoszenia nie może być późniejsza niż data rejestracji')}}
                    </small>
                </span>
                <input type="hidden" name="reported_at" :value="reportedAt"></input>
            </div>

            <div class="form-group" v-if="additionalInfoField">
                <label for="additional_info">{{ $lang('Pole dodatkowe') }} </label>
                <input type="text" id="additional_info" class="form-control" v-model="additionalInfo"
                       name="additional_info">
                </input>
            </div>
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-12 p-0 panel-heading mt-5" role="tab">
            <button type="button" class="btn-no-style col-12 p-0 text-left panel-title" data-toggle="collapse"
                    data-parent="#accordion" href="#taskFiles" aria-expanded="true" aria-controls="taskFiles">
                <h4 class="font-weight-bold">{{ $lang('Załącz pliki') }}</h4>
                <hr class="colorgraph">
            </button>
        </div>
        <div id="taskFiles" class="panel-collapse collapse show" role="tabpanel">
            <dropzone
                :route_store="attachment_store_route"
                :route_delete="attachment_delete_route"
            ></dropzone>
        </div>

        <dropzone-submit :delete_route="attachment_delete_route" :csrf="csrf">
            <template v-slot:submit-button="{submit}">
                <button class="pull-right btn btn-primary  mt-3 mb-3"
                        type="submit" id="submitBtn" :disabled="submitting">
                    {{ $lang('Zapisz') }}
                </button>
            </template>
        </dropzone-submit>
    </form>
</template>

<script>
import UsefulLinks from "../../useful-task-link/useful-links";
import DropzoneSubmit from "../../dropzone-submit";
import Dropzone from "../../dropzone";
import LibrariesChooser from "../../libraries-chooser";
import DatepickerAccessible from "../../datepicker-accessible";
import Autocomplete from '@trevoreyre/autocomplete-vue';
import ShowNotification from "../../../mixins/show-notification";
import {EventBus} from "../../../mixins/event-bus";
import axios from "axios";
import moment from "moment";

export default {
    name: 'oracle-task-create-form',
    components: {LibrariesChooser, Autocomplete, UsefulLinks, DropzoneSubmit, Dropzone, DatepickerAccessible},
    mixins: [ShowNotification],
    props: {
        csrf: String,
        store_route: String,
        attachment_store_route: String,
        attachment_delete_route: String,
        person_autocomplete_route: String,
        add_person_route: String,
        update_people_route: String,
        get_project_data_route: String,
        libraries: Array,
        is_admin: Boolean,
        client: Object,
        useful_links: Array,
        user: Object,
        can_add_people: Boolean,
    },
    data() {
        return {
            name: '',
            surname: '',
            email: '',
            phone: '',
            systems: null,
            modules: null,
            basicCriteria: null,
            priorityCriteria: null,
            libraryID: 0,
            projectID: null,
            moduleID: 0,
            systemID: 0,
            systemVersion: null,
            databaseVersion: null,
            osVersion: null,
            systemVersionEdit: true,
            databaseVersionEdit: true,
            osVersionEdit: true,
            contractNo: null,
            subject: '',
            description: '',
            for_all_info: false,
            person_id: null,
            allPeople: [],
            criterionType: null,
            hasLinks: false,
            serviceType: this.client.service_type,
            basicCriterion: 0,
            priorityCriterion: 0,
            source: 'www',
            reportedAt: '-',
            sources: [
                {name: 'www', projects: [1, 2, 3, 4, 5]},
                {name: 'telefon', projects: [1, 2, 3, 4, 5]},
                {name: 'e-mail', projects: [1, 2, 3, 4, 5]}
            ],
            additionalInfoField: false,
            additionalInfo: null,
            additionalContact: null,
            errors: [],
            submitting: false,
        }
    },
    computed: {
        systemPointerEvents() {
            return (this.systems && this.systems.length === 1) ? 'none' : 'auto';
        },
        sourcesForProject() {
            //na ten moment wszystkie opcje są dostępne dla wszystki
            return [{name: 'www'}, {name: 'telefon'}, {name: 'e-mail'}];
            //return this.sources.filter(source => source.projects.includes(this.projectID));
        }
    },
    created() {
        if (this.is_admin) {
            if (this.libraries.length === 1) {
                this.libraryID = this.libraries[0].id;
            } else {
                this.listenForLibraryChange();
            }
            this.updatePeople();
        } else {
            this.name = this.user.name;
            this.surname = this.user.surname;
            this.email = this.user.email;
            this.phone = this.user.phone;
            this.person_id = this.user.id;
            this.libraryID = this.client.id;
        }
        if (this.libraryID !== 0) {
            this.getDataForProject();
        }
    },
    methods: {
        checkValidation(e) {
            this.errors = [];
            let isValid = true;

            if (!this.libraryID) {
                isValid = false;
                this.errors['libraryID'] = 'libraryID';
            }
            if (this.libraryID && !this.contractNo) {
                isValid = false;
            }
            if (!this.surname) {
                isValid = false;
                this.errors['surnameInput'] = 'surnameInput';
            }
            if (!this.name) {
                isValid = false;
                this.errors['nameInput'] = 'nameInput';
            }
            if (!this.validateEmail(this.email)) {
                isValid = false;
                this.errors['email'] = 'email';
            }
            if (this.name && this.surname && this.email && this.is_admin && !this.validatePerson()) {
                isValid = false;
                this.errors['surnameInput'] = 'surnameInput';
                this.errors['nameInput'] = 'nameInput';
            }
            if (this.libraryID && !this.systemID) {
                isValid = false;
                this.errors['systemID'] = 'systemID';
            }
            if (this.libraryID && !this.systemVersion) {
                isValid = false;
                this.errors['systemVersion'] = 'systemVersion';
            }
            if (this.libraryID && !this.databaseVersion) {
                isValid = false;
                this.errors['databaseVersion'] = 'databaseVersion';
            }
            if (this.libraryID && !this.osVersion) {
                isValid = false;
                this.errors['osVersion'] = 'osVersion';
            }
            if (!this.moduleID) {
                isValid = false;
                this.errors['moduleID'] = 'moduleID';
            }
            if (!this.basicCriterion && !this.criterionType) {
                isValid = false;
                this.errors['basicCriterion'] = 'basicCriterion';
            }
            if (this.basicCriterion && !this.priorityCriterion && !this.criterionType) {
                isValid = false;
                this.errors['priorityCriterion'] = 'priorityCriterion';
            }
            if (!this.subject || !this.subject.trim()) {
                isValid = false;
                this.errors['subject'] = 'subject';
            }
            if (!this.description || !this.description.trim()) {
                isValid = false;
                this.errors['description'] = 'description';
            }
            if (!this.source) {
                isValid = false;
                this.errors['source'] = 'source';
            }
            if (this.reportedAt !== '-') {
                let currentDate = new Date().setSeconds(0,0);
                let chosenDate = Date.parse(this.reportedAt);

                if (!chosenDate) {
                    isValid = false;
                    this.errors['reportedAt'] = 'date_format';
                } else if (chosenDate > currentDate) {
                    isValid = false;
                    this.errors['reportedAt'] = 'later_date';
                }
            }
            if (isValid) {
                this.submitting = true;
                return true;
            }
            let firstError = Object.entries(this.errors)[0][0];
            this.expandErrorSectionsIfCollapsed();
            this.$refs[firstError].scrollIntoView({behavior: "smooth"});
            e.preventDefault();
        },
        validatePerson() {
            for (const person of this.allPeople) {
                if (person.name.replace(/\s/g, "") === this.name.replace(/\s/g, "")
                    && person.surname.replace(/\s/g, "") === this.surname.replace(/\s/g, "")) {
                    return true;
                }
            }
            return false;
        },
        validateEmail(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        searchPeopleName(input) {
            this.name = input
            let results = [];
            if (input.length >= 0) {
                this.allPeople.forEach(function (person) {
                    if (person.name.toLowerCase().includes(input.toLowerCase())) {
                        results.push({name: person.name, surname: person.surname, id: person.id})
                    }
                })
            }
            return [...new Set(results)];
        },
        searchPeopleSurname(input) {
            this.surname = input
            let results = [];
            if (input.length >= 0) {
                this.allPeople.forEach(function (person) {
                    if (person.surname.toLowerCase().includes(input.toLowerCase())) {
                        results.push({name: person.name, surname: person.surname, id: person.id})
                    }
                })
            }
            return [...new Set(results)];
        },
        getResult(result) {
            return result.surname + ' ' + result.name
        },
        handleName(result) {
            if (typeof result !== 'undefined') {
                this.name = result.name;
                this.surname = result.surname;
                this.person_id = result.id;
                result = result.name;
                this.autocomplete();
            }
        },
        handleSurname(result) {
            if (typeof result !== 'undefined') {
                this.surname = result.surname;
                this.name = result.name;
                this.person_id = result.id;
                result = result.surname;
                this.autocomplete();
            }
        },
        autocomplete() {
            let self = this;
            if (this.name !== '' && this.surname !== '') {
                axios.get(this.person_autocomplete_route, {
                         params: {
                             personId: this.person_id,
                         }
                     })
                     .then(function (response) {
                         self.email = response.data['email'];
                         self.phone = response.data['phone'];
                         self.name = response.data['name'];
                         self.surname = response.data['surname'];
                         self.person_id = response.data['person_id'];
                         self.$refs.surname.setValue({name: '', surname: self.surname});
                         self.$refs.name.setValue({name: self.name, surname: ''});

                     })
                     .catch(function (error) {
                         console.log(error);
                     });
            }
        },
        updatePeople() {
            let self = this;
            axios.get(this.update_people_route, {
                params: {
                    libraryID: self.libraryID
                }
            })
                .then(function (response) {
                    self.allPeople = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        setCriterionType(criterion) {
            if (criterion === 'problem_status') {
                this.criterionType = this.crash_id;
            } else if (criterion === 'failure_status') {
                this.criterionType = this.technical_issue_id;
            }
            if (!document.getElementById('problem_status').checked && !document.getElementById('failure_status').checked) {
                this.criterionType = null;
            }
            this.setHasLinks(this.criterionType);
        },
        setHasLinks(criterion) {
            let criterionLinks = this.useful_links.filter(function (link) {
                for (const linkCriterion of link.criteria) {
                    if (linkCriterion.id === criterion) return link;
                }
            });

            this.hasLinks = criterionLinks.length > 0;
        },
        getDataForProject() {
            this.systemVersion = '';
            this.databaseVersion = '';
            this.osVersion = '';

            this.systemVersionEdit = true;
            this.databaseVersionEdit = true;
            this.osVersionEdit = true;
            this.systems = [];
            this.systemID = null;
            this.moduleID = 0;
            let self = this;
            axios.get(this.get_project_data_route, {
                     params: {
                         libraryId: self.libraryID
                     }
                 })
                 .then(function (response) {
                     self.modules = response.data.modules;
                     self.basicCriteria = response.data.basic_criteria;
                     self.priorityCriteria = response.data.priority_criteria;
                     self.systems = response.data.systems;
                     self.projectID = response.data.project_id;
                     self.contractNo = response.data.contract_no;
                     self.additionalInfoField = response.data.additional_info;

                     if (self.modules.length === 1) {
                         self.moduleID = self.modules[0].module_id;
                     }
                 }).catch(function (error) {
                    console.log(error);
                    self.showNotification('error', self.$lang('Wystąpił problem przy pobieraniu danych'));
                });
        },
        listenForLibraryChange() {
            EventBus.$on('libraryChangeEvent', (result) => {
                this.libraryID = result.library_id;
                this.criterionType = 0;
                this.basicCriterion = 0;

                this.getDataForProject();
            });
        },
        expandErrorSectionsIfCollapsed() {
            Object.entries(this.errors).forEach(error => {
                switch (error[0]) {
                    case 'libraryID':
                    case 'systemID':
                    case 'systemVersion':
                    case 'osVersion':
                        if (this.$refs.taskClientSectionButton.ariaExpanded === 'false') {
                            this.$refs.taskClientSectionButton.click();
                        }
                        break;
                    case 'surnameInput':
                    case 'nameInput':
                    case 'email':
                        if (this.$refs.taskPersonSectionButton.ariaExpanded === 'false') {
                            this.$refs.taskPersonSectionButton.click();
                        }
                        break;
                    case 'moduleID':
                    case 'basicCriterion':
                    case 'priorityCriterion':
                        if (this.$refs.taskTypeSectionButton && this.$refs.taskTypeSectionButton.ariaExpanded === 'false') {
                            this.$refs.taskTypeSectionButton.click();
                        }
                        break;
                    case 'subject':
                    case 'description':
                    case 'source':
                        if (this.$refs.taskDataSectionButton.ariaExpanded === 'false') {
                            this.$refs.taskDataSectionButton.click();
                        }
                        break;
                }
            });
        }
    },
    watch: {
        libraryID() {
           if (this.is_admin) {
               this.name = '';
               this.surname = '';
               this.email = '';
               this.phone = '';
               this.person_id = null;
               this.$refs.surname.value = '';
               this.$refs.name.value = '';
           }
            this.updatePeople();
        },
        basicCriterion() {
            this.priorityCriterion = 0;
            this.$nextTick(() => {
                this.criterionType =
                    !this.priorityCriteria.filter(criterion => criterion.part_of === this.basicCriterion).length ? this.basicCriterion : 0;
            })
        },
        priorityCriterion() {
            this.criterionType =
                this.priorityCriteria.filter(criterion => criterion.part_of === this.basicCriterion).length ? this.priorityCriterion : 0;
        },
        systems() {
            if (this.systems && this.systems.length === 1) {
                this.systemID = this.systems[0].product_id;
            }
        },
        systemID(newVal) {
            let currentSystem = this.systems.filter(x => x.product_id === newVal)[0];

            if (currentSystem) {
                this.systemVersion = currentSystem.system_version;
                this.databaseVersion = currentSystem.database_version;
                this.osVersion = currentSystem.os_version;
            }

            this.systemVersionEdit = [null, undefined, ''].includes(this.systemVersion);
            this.databaseVersionEdit = [null, undefined, ''].includes(this.databaseVersion);
            this.osVersionEdit = [null, undefined, ''].includes(this.osVersion);
        }

    },
}
</script>


<style scoped>
    .control-pre-filled {
        pointer-events: none !important;
    }
</style>
